import Vue from 'vue'
import Router from 'vue-router'

import Error404 from '@/pages/404.vue'
import Dashboard from '@/pages'
import DashboardIndex from '@/pages/index/index.vue'

import DashboardCondo from '@/pages/index/condo.vue'
import DashboardCondoIndex from '@/pages/index/condo/index.vue'
import DashboardCondoList from '@/pages/index/condo/_type/index.vue'
import DashboardCondoId from '@/pages/index/condo/_type/_id.vue'
import DashboardCondoIdEdit from '@/pages/index/condo/_type/_id/edit.vue'
import DashboardCondoIdContract from '@/pages/index/condo/_type/_id/contract.vue'
import DashboardCondoMap from '@/pages/index/condo/map.vue'
import DashboardCondoName from '@/pages/index/condo/name.vue'
import DashboardCondoNameIndex from '@/pages/index/condo/name/index.vue'
import DashboardCondoNameEdit from '@/pages/index/condo/name/edit.vue'
import DashboardCondoMapIndex from '@/pages/index/condo/map/index.vue'

import HouseIndex from '@/pages/index/house/index.vue'
import DashboardHouseList from '@/pages/index/house/_type/index.vue'
import DashboardHouseId from '@/pages/index/house/_type/_id.vue'
import DashboardHouseIdEdit from '@/pages/index/house/_type/_id/edit.vue'

import All from '@/pages/index/all.vue'

import DashboardUsers from '@/pages/index/users.vue'
import DashboardUsersIndex from '@/pages/index/users/index.vue'
import DashboardUsersEdit from '@/pages/index/users/edit.vue'
import DashboardUsersRepass from '@/pages/index/users/repass.vue'
import Login from '@/pages/login.vue'
import Logout from '@/pages/logout.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'Error404',
      component: Error404
    },
    {
      path: '/condo/pub',
      component: () => import('@/pages/public/index.vue'),
      children: [
        {
          path: '',
          component: () => import('@/pages/public/index.vue')
        },
        {
          path: ':id',
          component: () => import('@/pages/public/_id.vue')
        }
      ]
    },
    {
      path: '/',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: DashboardIndex,
          redirect: '/condo'
        },
        {
          path: 'all',
          component: All
        },
        {
          path: 'condo',
          component: DashboardCondo,
          children: [
            {
              path: '',
              name: 'Dashboard-Condo',
              component: DashboardCondoIndex
            },
            {
              path: 'map',
              component: DashboardCondoMap,
              children: [
                {
                  path: '',
                  name: 'Dashboard-Condo-Map',
                  component: DashboardCondoMapIndex
                }
              ]
            },
            {
              path: 'name',
              component: DashboardCondoName,
              children: [
                {
                  path: '',
                  name: 'Dashboard-Condo-Name',
                  component: DashboardCondoNameIndex
                },
                {
                  path: 'create',
                  name: 'Dashboard-Condo-Name-Create',
                  component: DashboardCondoNameEdit
                },
                {
                  path: ':id',
                  name: 'Dashboard-Condo-Name-Edit',
                  component: DashboardCondoNameEdit
                }
              ]
            },
            {
              path: ':type',
              component: DashboardCondoIndex,
              children: [
                {
                  path: '',
                  name: 'Dashboard-Condo-Type',
                  component: DashboardCondoList
                },
                {
                  path: 'create',
                  name: 'Dashboard-Condo-Create',
                  component: DashboardCondoIdEdit
                },
                {
                  path: ':id',
                  component: DashboardCondoId,
                  children: [
                    {
                      path: 'edit',
                      name: 'Dashboard-Condo-Edit',
                      component: DashboardCondoIdEdit
                    },
                    {
                      path: 'contract',
                      name: 'Dashboard-Condo-Contract',
                      component: DashboardCondoIdContract
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'house',
          component: DashboardCondo,
          children: [
            {
              path: '',
              name: 'Dashboard-House',
              component: HouseIndex
            },
            {
              path: 'map',
              component: DashboardCondoMap,
              children: [
                {
                  path: '',
                  name: 'Dashboard-House-Map',
                  component: DashboardCondoMapIndex
                }
              ]
            },
            {
              path: ':type',
              component: DashboardCondoIndex,
              children: [
                {
                  path: '',
                  name: 'Dashboard-House-Type',
                  component: DashboardHouseList
                },
                {
                  path: 'create',
                  name: 'Dashboard-House-Create',
                  component: DashboardHouseIdEdit
                },
                {
                  path: ':id',
                  component: DashboardHouseId,
                  children: [
                    {
                      path: 'edit',
                      name: 'Dashboard-House-Edit',
                      component: DashboardHouseIdEdit
                    },
                    {
                      path: 'contract',
                      name: 'Dashboard-House-Contract',
                      component: DashboardCondoIdContract
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'townhouse',
          component: DashboardCondo,
          children: [
            {
              path: '',
              name: 'Dashboard-Townhouse',
              component: HouseIndex
            },
            {
              path: 'map',
              component: DashboardCondoMap,
              children: [
                {
                  path: '',
                  name: 'Dashboard-Townhouse-Map',
                  component: DashboardCondoMapIndex
                }
              ]
            },
            {
              path: ':type',
              component: DashboardCondoIndex,
              children: [
                {
                  path: '',
                  name: 'Dashboard-Townhouse-Type',
                  component: DashboardHouseList
                },
                {
                  path: 'create',
                  name: 'Dashboard-Townhouse-Create',
                  component: DashboardHouseIdEdit
                },
                {
                  path: ':id',
                  component: DashboardHouseId,
                  children: [
                    {
                      path: 'edit',
                      name: 'Dashboard-Townhouse-Edit',
                      component: DashboardHouseIdEdit
                    },
                    {
                      path: 'contract',
                      name: 'Dashboard-Townhouse-Contract',
                      component: DashboardCondoIdContract
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'land',
          component: DashboardCondo,
          children: [
            {
              path: '',
              name: 'Dashboard-Land',
              component: HouseIndex
            },
            {
              path: 'map',
              component: DashboardCondoMap,
              children: [
                {
                  path: '',
                  name: 'Dashboard-Land-Map',
                  component: DashboardCondoMapIndex
                }
              ]
            },
            {
              path: ':type',
              component: DashboardCondoIndex,
              children: [
                {
                  path: '',
                  name: 'Dashboard-Land-Type',
                  component: DashboardHouseList
                },
                {
                  path: 'create',
                  name: 'Dashboard-Land-Create',
                  component: DashboardHouseIdEdit
                },
                {
                  path: ':id',
                  component: DashboardHouseId,
                  children: [
                    {
                      path: 'edit',
                      name: 'Dashboard-Land-Edit',
                      component: DashboardHouseIdEdit
                    },
                    {
                      path: 'contract',
                      name: 'Dashboard-Land-Contract',
                      component: DashboardCondoIdContract
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'building',
          component: DashboardCondo,
          children: [
            {
              path: '',
              name: 'Dashboard-Building',
              component: HouseIndex
            },
            {
              path: 'map',
              component: DashboardCondoMap,
              children: [
                {
                  path: '',
                  name: 'Dashboard-Building-Map',
                  component: DashboardCondoMapIndex
                }
              ]
            },
            {
              path: ':type',
              component: DashboardCondoIndex,
              children: [
                {
                  path: '',
                  name: 'Dashboard-Building-Type',
                  component: DashboardHouseList
                },
                {
                  path: 'create',
                  name: 'Dashboard-Building-Create',
                  component: DashboardHouseIdEdit
                },
                {
                  path: ':id',
                  component: DashboardHouseId,
                  children: [
                    {
                      path: 'edit',
                      name: 'Dashboard-Building-Edit',
                      component: DashboardHouseIdEdit
                    },
                    {
                      path: 'contract',
                      name: 'Dashboard-Building-Contract',
                      component: DashboardCondoIdContract
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'users',
          component: DashboardUsers,
          children: [
            {
              path: '',
              name: 'Dashboard-Users',
              component: DashboardUsersIndex
            },
            {
              path: 'create',
              name: 'Dashboard-Users-Create',
              component: DashboardUsersEdit
            },
            {
              path: ':id',
              name: 'Dashboard-Users-Edit',
              component: DashboardUsersEdit
            },
            {
              path: ':id/repass',
              name: 'Dashboard-Users-Repass',
              component: DashboardUsersRepass
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js